import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router';
import { Splash } from './routes/Splash.js';
import { Menu } from './routes/Menu.js';
import { Lobby } from './routes/Lobby.js';
import { Collection } from './routes/Collection.js';
import { GameOver } from './routes/GameOver.js';

const Battle = lazy(() => import('./routes/Battle.js').then((m) => ({ default: m.Battle })));

export const router = createBrowserRouter([
  { path: '/', element: <Splash /> },
  { path: '/menu', element: <Menu /> },
  { path: '/lobby', element: <Lobby /> },
  { path: '/collection', element: <Collection /> },
  {
    path: '/battle/:mode',
    element: (
      <Suspense fallback={<BattleLoading />}>
        <Battle />
      </Suspense>
    ),
  },
  { path: '/gameover', element: <GameOver /> },
  { path: '*', element: <Navigate to="/" replace /> },
]);

function BattleLoading() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100dvh' }}>
      <div style={{ letterSpacing: '0.32em', fontSize: 14, opacity: 0.7 }}>DEALING…</div>
    </div>
  );
}
